import { useSeoQuery } from "./graphql/query";

export const useSeoData = (keyword) => {
  const { meta_title, meta_description, meta_keyword } = useSeoQuery(keyword);
  return { meta_title, meta_description, meta_keyword };
};
